import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayDiscrepanciesService } from 'app/singleton-services/display-discrepancies.service';

@Component({
    selector: 'app-discrepancy-switch',
    template: `
        <div class="d-flex align-items-center justify-content-end">
            <span
                class="btn btn-sm btn-info cursor-pointer"
                kendoTooltip
                title="{{ 'Switch between values and discrepancies.' | translate }}"
                (click)="toggleDiscrepancies()">
                <fa-icon [icon]="['fas', displayDiscrepancies ? 'ruler-horizontal' : 'calculator']"></fa-icon>
            </span>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DiscrepancySwitchComponent {
    constructor(private displayDiscrepanciesService: DisplayDiscrepanciesService) {}

    get displayDiscrepancies(): boolean {
        return this.displayDiscrepanciesService.displayDiscrepancies;
    }

    toggleDiscrepancies(): void {
        this.displayDiscrepanciesService.displayDiscrepancies = !this.displayDiscrepanciesService.displayDiscrepancies;
    }
}
